import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "@fontsource/chivo";
import {
  FiList,
  FiLogOut,
  FiEye,
  FiEyeOff,
  FiMaximize,
  FiMinimize,
  FiBookOpen,
  FiBell,
} from "react-icons/fi";
import { FaUmbrellaBeach, FaTags, FaUtensils,FaCalendarCheck } from "react-icons/fa";

const AdminNavbar = ({ newOrderCount }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLinks, setShowLinks] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/");
  };

  const navItems = [
    { label: "Riepilogo Ordini", path: "/admin-panel", icon: <FiList /> },
    {
      label: "Modalità Servizio",
      path: "/admin-servizio",
      icon: <FaUtensils />,
      badge: newOrderCount > 0 ? newOrderCount : null,
    },
    { label: "Gestione Menu", path: "/admin-menu", icon: <FiBookOpen /> },
    { label: "Gestione Sconti", path: "/admin-sconti", icon: <FaTags /> },
    { label: "Gestione Posti", path: "/admin-posti", icon: <FaUmbrellaBeach /> },
    { label: "Abbonamenti", path: "/admin-abbonamenti", icon: <FaCalendarCheck /> },

  ];

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => {
        setIsFullscreen(true);
      });
    } else {
      document.exitFullscreen().then(() => {
        setIsFullscreen(false);
      });
    }
  };

  return (
    <nav className="bg-[#009FB7] text-white px-4 py-4 shadow-md">
      {/* Title + Toggle */}
      <div className="flex items-center justify-between sm:justify-start mb-4 sm:mb-2">
        <div className="text-2xl font-[chivo] font-semibold mr-4">
          LidoDaVittorio.it
        </div>
        <button
          onClick={() => setShowLinks((prev) => !prev)}
          className="text-white hover:text-gray-200 transition"
        >
          {showLinks ? <FiEyeOff size={20} /> : <FiEye size={20} />}
        </button>
        <button
          onClick={toggleFullscreen}
          className="text-white hover:text-gray-200 transition ml-3"
          title={isFullscreen ? "Esci da Schermo Intero" : "Schermo Intero"}
        >
          {isFullscreen ? <FiMinimize size={20} /> : <FiMaximize size={20} />}
        </button>
      </div>

      {/* Nav links and logout */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 flex-wrap">
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 items-start sm:items-center">
          {showLinks &&
            navItems.map((item) => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`relative flex items-center gap-2 font-[chivo] px-4 py-2 rounded-md transition w-full sm:w-auto ${
                  location.pathname === item.path
                    ? "bg-white text-[#009FB7] font-semibold"
                    : "hover:bg-[#007d99]"
                }`}
              >
                {item.icon}
                {item.label}
                {item.badge && (
                  <span className="ml-1 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                    {item.badge}
                  </span>
                )}
              </button>
            ))}
        </div>

        {showLinks && (
          <div className="flex items-center gap-4">
{newOrderCount > 0 && (
  <div className="flex items-center gap-2">
    <button
      onClick={() => navigate("/admin-servizio")}
      className="relative group cursor-pointer"
      title="Nuovi ordini ricevuti"
      aria-label="Notifiche nuovi ordini"
    >
      <FiBell className="text-white text-xl" />
      <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
        {newOrderCount}
      </span>
    </button>
    <span className="text-sm font-bold text-green-300 animate-neon">
      Nuovo/i ordini ricevuti
    </span>
  </div>
)}



            <button
              onClick={handleLogout}
              className="flex items-center justify-center gap-2 bg-red-500 text-white font-[chivo] px-4 py-2 rounded-md hover:bg-red-600 w-full sm:w-auto"
            >
              <FiLogOut />
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default AdminNavbar;
